import { metricsService } from '@fiverr-private/listing_lib';

export const reportHighlightRecommendationRendered = (componentName) =>
    metricsService.count(`listings.highlight_recommendation_render.${componentName}`);
